import { c as _c } from "react/compiler-runtime";
import React from 'react';
import styled from 'styled-components';
import { getBreakpointFromProps } from './utils';
import { Breakpoint, MediaProps } from './types';
import { breakpoints } from './constants';
const HideBelowWrapper = styled.div<{
  breakpoint: Breakpoint;
}>`
    display: block;

    @media (max-width: ${({
  breakpoint
}) => breakpoints[breakpoint]}px) {
        display: none;
    }
`;
const HideBelow = props => {
  const $ = _c(5);
  const {
    children
  } = props;
  let t0;
  if ($[0] !== props) {
    t0 = getBreakpointFromProps(props);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== children || $[3] !== t0) {
    t1 = <HideBelowWrapper breakpoint={t0}>{children}</HideBelowWrapper>;
    $[2] = children;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export default HideBelow;